import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import MyText from "../custom/MyText";
import { white } from "../../colors";
import { useNavigation } from "@react-navigation/native";

export default function GrowthTestButton({
  title,
  index,
  screen,
  childId,
  newInput,
}) {
  const navigation = useNavigation();
  const colorList = ["#48A9C2", "#FF9356", "#A7CA8D", "#9371BE"];
  return (
    <TouchableOpacity
      onPress={() =>
        navigation.navigate("GrowthTest", {
          childId: childId,
          testType: screen,
          title: title,
        })
      }
      style={{
        width: "100%",
        backgroundColor: colorList[index % 4],
        padding: 10,
        paddingVertical: 30,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        marginVertical: 10,
      }}
    >
      <MyText style={{ fontSize: 20, color: white }}>{`${title}`}</MyText>
    </TouchableOpacity>
  );
}
